import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@api/client';
import type { ApprovalChain } from '@api/hooks/useApprovalChains';
import { CreateChainWizard } from './CreateChainWizard';

interface EditChainModalProps {
  chainId: string;
  onClose: () => void;
  onSuccess: () => void;
  simpleMode: boolean;
}

export const EditChainModal = ({
  chainId,
  onClose,
  onSuccess,
  simpleMode,
}: EditChainModalProps) => {
  const { data: chain, isLoading } = useQuery({
    queryKey: ['approval-chain', chainId],
    queryFn: async () => {
      const response = await apiClient.get<ApprovalChain>(`/approval-chains/${chainId}`);
      return response.data;
    },
  });

  if (isLoading || !chain) {
    return (
      <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
        <div className="bg-white dark:bg-gray-900 rounded-lg p-8">
          <div className="animate-spin rounded-full h-8 w-8 border border-blue-300 border-t-blue-600"></div>
        </div>
      </div>
    );
  }

  return (
    <CreateChainWizard
      mode="edit"
      chainId={chainId}
      initialData={chain}
      initialSimpleMode={simpleMode}
      onClose={onClose}
      onSuccess={onSuccess}
    />
  );
};
